import { observable, action, makeAutoObservable, runInAction } from "mobx";
import { message, notification } from "antd";
import { persist } from 'mobx-persist';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

class OrganizationStore {

    @observable loading = false;
    @observable isSuccess = false;

    @observable perPage = 10;
    @observable hasMore = false;
    @observable page = 1;

    @observable members = [];

    constructor() {
        makeAutoObservable(this);
    }

    @action
    createNewMember = async (values) => {
        
        this.loading = true;
        
        try {
            const response = await axios.post(`/organization/create_member.php`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Invite Added'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Invite Added",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        //REDIRECT TO THE LIST OF TEAM LEADERS
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'User Registration Error',
                    description: error.response.data.message
                });
                message.error('User Registration Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    fetchMembers = async (userID, userType) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/organization/get_all_members.php?referrerID=${userID}&userType=${userType}&perPage=${this.perPage}&page=${this.page}&sortBy=ASC`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            console.log()
            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.members = response.data.data;
                        if (this.members && this.members.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Events Error',
                    description: error.response.data.message
                });
                message.error('Fetching Events Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }
}

export default OrganizationStore;
